import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export const timeline = () => {
    const timelines = document.querySelectorAll('.timeline-block');

    if (!timelines.length) return;

    timelines.forEach(slider => {

        const swiper = new Swiper('.timeline--slider.swiper', {
            spaceBetween: 32,
            loop: false,
            observer: true,
            observeParents: true,
            slidesPerGroupSkip: 1,
            slidesPerView: 4,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    });
}